module.exports = __webpack_public_path__ + "img/lovoo.0c6de6b.svg";